var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"w-full",attrs:{"danger":_vm.rejected,"success":!_vm.rejected,"type":"button"},on:{"click":_vm.createConversation}},[(_vm.loading)?_c('Loader',{attrs:{"small":""}}):(_vm.rejected)?_c('span',[_vm._v("Something went wrong.")]):_c('span',[_vm._v("Start conversation")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }